import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { javascriptFormatRunner } from "#/features/codeRunner/lib/javascriptFormatRunner";

/**
 * Client-side JS formatting via Prettier in a Web Worker (symmetric with Python/Black).
 */
export const useJavaScriptFormatCode = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
async function _temp(code) {
  const {
    formatted,
    error
  } = await javascriptFormatRunner.formatCode(code);
  if (error !== null) {
    throw new Error(error);
  }
  return formatted;
}